import { render, staticRenderFns } from "./RescueOfGlobalClub.vue?vue&type=template&id=d5e906ba&scoped=true&"
import script from "./RescueOfGlobalClub.vue?vue&type=script&lang=js&"
export * from "./RescueOfGlobalClub.vue?vue&type=script&lang=js&"
import style0 from "./RescueOfGlobalClub.vue?vue&type=style&index=0&id=d5e906ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e906ba",
  null
  
)

export default component.exports